// @ts-nocheck
import React from "react";
import Anatytics from "src/components/Modules/Campaign/Analytics";

const Analytics = () => {
  return <Anatytics isShowTrack={true} />;
};

export default Analytics;
